<bricks-modal (closeDialog)="closeDialog()">
  <bricks-modal-header> Neue Technische Ressource hinzufügen </bricks-modal-header>
  <bricks-modal-body>
    <div class="icon-text">
      <bricks-icon
        color="primary"
        height="24px"
        width="24px"
        matTooltipPosition="left"
        matTooltipClass="tooltip-info-outline">
        bricks-info-filled
      </bricks-icon>
      <div class="content">
        <p>
          Wir setzen voraus, dass alle technischen Ressourcen zu einer gemeinsamen Marktlokation (MaLo) gehören und
          einer gemeinsamen steuerbaren Ressource (SR) zugeordnet sind. Der Marktlokation (MaLo) sowie der steuerbare
          Ressource (SR) dürfen keine weiteren technischen Ressourcen von Dritten zugeordnet sein.
        </p>
        <p>Nur so können wir Ihre Anlagen korrekt verwalten und ein passgenaues Angebot erstellen.</p>
      </div>
    </div>
    <div class="image-container">
      <img src="{{ image }}" alt="Resource" />
    </div>
    <div>
      <p><b>Was ist eine Technische Ressource (TR)?</b></p>
      <p>
        Eine physische Anlage, die Strom erzeugt, verbraucht oder speichert – zum Beispiel eine Solaranlage, eine
        Batterie oder ein Windrad.
      </p>
      <br />
      <p><b>Was ist eine Steuerbare Ressource (SR)?</b></p>
      <p>
        Eine Steuerbare Ressource (SR) ist eine Einheit oder Zusammenfassung mehrerer technischer Ressourcen (TRs), die
        vom Netzbetreiber gezielt gesteuert werden kann. Bei mehreren Windkraftanlagen könnte beispielsweise ein
        Windpark, der aus mehreren einzelnen Windenergieanlagen (TRs) besteht, als eine Steuerbare Ressource (SR)
        betrachtet werden, wenn er über einen zentralen Punkt gemeinsam angesprochen und in seiner Einspeisung reduziert
        werden kann.
      </p>
      <br />
      <p><b>Was ist eine Marktlokation (MaLo)?</b></p>
      <p>
        Eine Marktlokation ist ein eindeutig definierter Ort, an dem Energie entweder erzeugt oder verbraucht wird und
        der als Anknüpfungspunkt für die Bilanzierung und Abrechnung dient. Sie wird durch eine unveränderliche
        Marktlokations-ID (MaLo-ID) identifiziert, welche durch den Netzbetreiber vergeben wird.
      </p>
    </div>
  </bricks-modal-body>
  <bricks-modal-footer>
    <button type="button" class="bricks-button button-primary button-fn" (click)="closeDialog()">
      <span>Zur Kenntnis genommen</span>
    </button>
  </bricks-modal-footer>
</bricks-modal>
